<template>
  <div class="yxtbiz-flip-info" v-loading="loadingData">
    <div class="">
      <span class="color-8c">{{ $t('pc_biz_o2o_lbl_face_name' /* 面授名称 */) }}：</span>
      <span class="color-26">{{info.name}}</span>
    </div>
    <div class="mt16 layout-flex">
      <span class="color-8c flex-shrink-0">{{ $t('pc_ulcd_lbl_offlinedesc' /* 面授说明 */) }}：</span>
      <div v-if="info.description" class="color-26" style="margin-top: -14px;" v-html="info.description"></div>
      <span v-else class="color-26">-</span>
    </div>
    <div class="layout-flex mt16 layout-flex-wrap">
      <div
        v-for="(item, index) in flipLists"
        :key="item.id"
        class="offline-sence-item mr16 mt16 border-box"
      >
        <div class="color-gray-10 weight-bold lh22 mb16 ellipsis">
          <yxt-tooltip placement="top" :open-filter="true">
            <div class="ellipsis"><span class="mr4">{{ $t('pc_o2o_lbl_sence_no', [index + 1]) }}</span>{{ item.sceneName }}</div>
            <div slot="content">
              <span class="mr4">{{ $t('pc_o2o_lbl_sence_no', [index + 1]) }}</span>{{ item.sceneName }}
            </div>
          </yxt-tooltip>
        </div>
        <!-- 签到时间 -->
        <div class="layout-flex layout-align-center mr32 color-gray-8 over-hidden">
          <yxt-svg
            icon-class="common_time"
            width="16px"
            height="16px"
            class="color-gray-6 mr8 flex-shrink-0"
          />
          <yxt-tooltip placement="top" :content="`${item.startTime}~${item.endTime}`" :open-filter="true">
            <span class="d-in-block ellipsis color-gray-7">{{ `${item.startTime}~${item.endTime}` }}</span>
          </yxt-tooltip>
        </div>
        <!-- 签到地点 -->
        <div class="layout-flex layout-align-center mt8 over-hidden">
          <yxt-svg
            :remote-url="`${$staticBaseUrl}ufd/55a3e0/o2o/pc/svg`"
            class="color-gray-6 mr8 flex-shrink-0"
            width="16px"
            height="16px"
            icon-class="address"
          />
          <yxt-tooltip placement="top" :content="item.locationName" :open-filter="true">
            <span class="ellipsis color-gray-7">{{ (item.locationName + item.address) || '--' }}</span>
          </yxt-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { getFlipInfoAndScenes } from './service';
export default {
  name: 'YxtbizFlipInfo',
  name_zh: '面授信息',
  props: {
    taskId: {
      type: String,
      default: '',
      desc: '面授任务id',
      setter: 'StringSetter'
    },
    isGroup: {
      type: Boolean,
      default: false,
      desc: '是否集团版',
      setter: 'BooleanSetter'
    }
  },

  data() {
    return {
      loadingData: false,
      info: {},
      flipLists: []
    };
  },
  created() {
    // 获取面授详情
    this.getFlipDetail();
  },
  methods: {
    // 获取面授详情
    getFlipDetail() {
      this.loadingData = true;
      getFlipInfoAndScenes(this.taskId).then(({name, description, scenes}) => {
        this.info = {name, description};
        this.flipLists = scenes;
      }).finally(() => {
        this.loadingData = false;
      });
    }
  }
};
</script>
